<template>
  <div class="pricing-page">
    <section>
      <div class="container py-5">

        <!-- FOR DEMO PURPOSE -->
        <header class="text-center mb-5">
          <div class="row">
            <div class="col-lg-7 mx-auto">
              <img src="../assets/images/logo-dark.png" class="logo-img" alt="">
              <p>Our pricing tiers address the different needs of our partners based on the size of their client base and business goals. You can cancel your subscription anytime by emailing info@ontrac.app</p>

              <div class="col-12 d-flex justify-content-center">
                <div role="group" class="btn-group-pill btn-group">
                  <button
                    type="button"
                    :class="'btn ' + (paymentType === 'monthly' ? 'btn-primary' : 'btn-light')"
                    @click="paymentType = 'monthly'"
                  >Monthly</button>
                  <button
                    type="button"
                    class="btn btn-primary"
                    :class="'btn ' + (paymentType === 'yearly' ? 'btn-primary' : 'btn-light')"
                    @click="paymentType = 'yearly'"
                  >Yearly</button>
                </div>
              </div>
            </div>
          </div>
        </header>
        <!-- END -->

        <div class="row">
          <div class="col-lg-8 mb-5 mb-lg-0">
            <div v-if="paymentType === 'monthly'" class="row text-center justify-content-center">
              <!-- Pricing Table-->
              <div class="col-lg-6 mb-5 mb-lg-0">
                <div class="bg-white p-5 rounded-lg shadow">
                  <h1 class="h6 text-uppercase font-weight-bold mb-4">Starter</h1>
                  <h2 class="h1 font-weight-bold">$37.50<span class="text-small font-weight-normal ml-2">/ month</span></h2>

                  <div class="custom-separator my-4 mx-auto bg-primary"></div>

                  <ul class="list-unstyled my-5 text-small text-left">
                    <li class="mb-3">
                      <i class="fa fa-check mr-2 text-primary"></i> SMARTrac Builder Tool</li>
                    <li class="mb-3">
                      <i class="fa fa-check mr-2 text-primary"></i> Unlimited Authored SMARTracs</li>
                    <li class="mb-3">
                      <i class="fa fa-check mr-2 text-primary"></i> Private SMARTrac Library (For Your Clients/Users Only)</li>
                    <li class="mb-3">
                      <i class="fa fa-check mr-2 text-primary"></i> Track Progress Up to 20 Active Clients/Users</li>
                  </ul>
                  <button
                      @click="submit('starterMonthly')"
                      class="btn btn-primary btn-block p-2 shadow rounded-pill"
                      :class="{'loading': loading}"
                      :disabled="loading"
                  >Subscribe</button>
                </div>
              </div>
              <!-- END -->


              <!-- Pricing Table-->
              <div class="col-lg-6 mb-5 mb-lg-0">
                <div class="bg-white p-5 rounded-lg shadow">
                  <h1 class="h6 text-uppercase font-weight-bold mb-4">Professional</h1>
                  <h2 class="h1 font-weight-bold">$62.50<span class="text-small font-weight-normal ml-2">/ month</span></h2>

                  <div class="custom-separator my-4 mx-auto bg-primary"></div>

                  <ul class="list-unstyled my-5 text-small text-left">
                    <li class="mb-3">
                      <i class="fa fa-check mr-2 text-primary"></i> SMARTrac Builder Tool</li>
                    <li class="mb-3">
                      <i class="fa fa-check mr-2 text-primary"></i> Unlimited Authored SMARTracs</li>
                    <li class="mb-3">
                      <i class="fa fa-check mr-2 text-primary"></i> Private SMARTrac Library (For Your Clients/Users Only)</li>
                    <li class="mb-3">
                      <i class="fa fa-check mr-2 text-primary"></i> Track Progress Up to 50 Active Clients/Users</li>
                  </ul>
                  <button
                      @click="submit('professionalMonthly')"
                      class="btn btn-primary btn-block p-2 shadow rounded-pill"
                      :class="{'loading': loading}"
                      :disabled="loading"
                  >Subscribe</button>
                </div>
              </div>
              <!-- END -->

            </div>

            <div v-if="paymentType === 'yearly'" class="row text-center justify-content-center">
              <!-- Pricing Table-->
              <div class="col-lg-6 mb-5 mb-lg-0">
                <div class="bg-white p-5 rounded-lg shadow">
                  <h1 class="h6 text-uppercase font-weight-bold mb-4">Starter</h1>
                  <h2 class="h1 font-weight-bold">$375<span class="text-small font-weight-normal ml-2">/ year</span></h2>

                  <div class="custom-separator my-4 mx-auto bg-primary"></div>

                  <ul class="list-unstyled my-5 text-small text-left">
                    <li class="mb-3">
                      <i class="fa fa-check mr-2 text-primary"></i> SMARTrac Builder Tool</li>
                    <li class="mb-3">
                      <i class="fa fa-check mr-2 text-primary"></i> Unlimited Authored SMARTracs</li>
                    <li class="mb-3">
                      <i class="fa fa-check mr-2 text-primary"></i> Private SMARTrac Library (For Your Clients/Users Only)</li>
                    <li class="mb-3">
                      <i class="fa fa-check mr-2 text-primary"></i> Track Progress Up to 20 Active Clients/Users</li>
                  </ul>
                  <button
                      @click="submit('starterYearly')"
                      class="btn btn-primary btn-block p-2 shadow rounded-pill"
                      :class="{'loading': loading}"
                      :disabled="loading"
                  >Subscribe</button>
                </div>
              </div>
              <!-- END -->


              <!-- Pricing Table-->
              <div class="col-lg-6 mb-5 mb-lg-0">
                <div class="bg-white p-5 rounded-lg shadow">
                  <h1 class="h6 text-uppercase font-weight-bold mb-4">Professional</h1>
                  <h2 class="h1 font-weight-bold">$562.50<span class="text-small font-weight-normal ml-2">/ year</span></h2>

                  <div class="custom-separator my-4 mx-auto bg-primary"></div>

                  <ul class="list-unstyled my-5 text-small text-left">
                    <li class="mb-3">
                      <i class="fa fa-check mr-2 text-primary"></i> SMARTrac Builder Tool</li>
                    <li class="mb-3">
                      <i class="fa fa-check mr-2 text-primary"></i> Unlimited Authored SMARTracs</li>
                    <li class="mb-3">
                      <i class="fa fa-check mr-2 text-primary"></i> Private SMARTrac Library (For Your Clients/Users Only)</li>
                    <li class="mb-3">
                      <i class="fa fa-check mr-2 text-primary"></i> Track Progress Up to 50 Active Clients/Users</li>
                  </ul>
                  <button
                      @click="submit('professionalYearly')"
                      class="btn btn-primary btn-block p-2 shadow rounded-pill"
                      :class="{'loading': loading}"
                      :disabled="loading"
                  >Subscribe</button>
                </div>
              </div>
              <!-- END -->

            </div>
          </div>
          <div class="col-lg-4 mb-5 mb-lg-0">
            <div class="row text-center justify-content-center h-100">
              <div class="col-lg-12 mb-5 mb-lg-0">
                <div class="bg-white p-5 rounded-lg shadow h-100">
                  <h1 class="h6 text-uppercase font-weight-bold mb-4">Enterprise</h1>
                  <h2 class="h1 font-weight-bold">Contact Us</h2>

                  <div class="custom-separator my-4 mx-auto bg-primary"></div>

                  <ul class="list-unstyled my-5 text-small text-left font-weight-normal" style="height: 174px;">
                    <li class="mb-3">
                      <i class="fa fa-check mr-2 text-primary"></i> For partners who have 50+ active clients/users and need a more customized solution</li>
                  </ul>
                  <a href="https://www.startontrac.com/contact-us"><button
                      class="btn btn-primary btn-block p-2 shadow rounded-pill"
                  >Contact Us</button></a>
                </div>
              </div>
            </div>
          </div>
        </div>


      </div>
    </section>

    <div class="status-modal error-page" v-if="pageStatus === '1'">
      <div class="status-content">
        <feather type="x" stroke="#c23d4b" size="50"></feather>
        <h2>UnSuccessful</h2>
        <p>Checkout process did not complete successfully!</p>
        <button class="btn btn-primary" @click="$router.push('/upgrade'); pageStatus = ''">Try again</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "upgrade",
  data () {
    return {
      publishableKey: process.env.VUE_APP_STRIPE_PUBLISHABLE_KEY,
      pageStatus: '',
      paymentType: 'monthly',
      loading: false,
      starterMonthly: [
        {
          price: 'price_1J5FBvEKCPMp2dGPRb3uPeOe', // The id of the recurring price you created in your Stripe dashboard
          quantity: 1,
        },
      ],
      starterYearly: [
        {
          price: 'price_1J5FCCEKCPMp2dGPI3m9FTrG', // The id of the recurring price you created in your Stripe dashboard
          quantity: 1,
        },
      ],
      professionalMonthly: [
        {
          price: 'price_1J5FCXEKCPMp2dGPuRKjGmqU', // The id of the recurring price you created in your Stripe dashboard
          quantity: 1,
        },
      ],
      professionalYearly: [
        {
          price: 'price_1J5FCoEKCPMp2dGPqE2zKWJx', // The id of the recurring price you created in your Stripe dashboard
          quantity: 1,
        },
      ],
      clientReferenceId: '',
      customerEmail: '',
      successURL: '',
      cancelURL: window.location.origin + '/upgrade?e=1',
    };
  },
  created() {
    this.pageStatus = this.$route.query.e;
    this.clientReferenceId = localStorage.getItem('userId')
    this.customerEmail = JSON.parse(localStorage.getItem('userinfo'))
    this.successURL = window.location.origin + '/tier-change/' + window.btoa(this.clientReferenceId)
  },
  methods: {
    async submit (element) {
      localStorage.setItem('upgrading', window.btoa('upgrading'))
      const payload = {
        successUrl: this.successURL,
        cancelUrl: this.cancelURL,
        lineItems: this[element],
        clientReferenceId: this.clientReferenceId,
        customerEmail: this.customerEmail.email
      }
      this.loading = true
      let res = await this.$store.dispatch('stripeCheckoutLink', payload)
      if (res.status === 200 && res.data.statusCode === 200) {
        let resData = JSON.parse(res.data.message)
        window.location.href = resData.url
      }
      this.loading = false
    },
  },
}
</script>

<style scoped lang="scss">
.pricing-page {
  background: #f6f6f699;
  min-height: 100vh;
  background-image: url("http://vue.pixelstrap.com/endless/img/coming-soon-bg.bc1fb2a6.jpg");

  .logo-img {
    width: 250px;
    margin-bottom: 25px;
  }
}

.rounded-lg {
  border-radius: 1rem !important;
}

.text-small {
  font-size: 0.9rem !important;
}

.custom-separator {
  width: 5rem;
  height: 6px;
  border-radius: 1rem;
}

.text-uppercase {
  letter-spacing: 0.2em;
}

.status-modal {
  position: fixed;
  z-index: 9;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #21212166;

  .status-content {
    background-color: #fff;
    box-shadow: 0 11px 15px -7px #00000033, 0 24px 38px 3px #00000024, 0 9px 46px 8px #0000001f;
    border-radius: 4px;
    padding: 40px;
    text-align: center;

    i {
      color: #24b47e;
      width: 50px;
    }
  }
}
</style>
